/**
 * DecorativeCloud — soft SVG cloud shape with gentle float animation
 */

import { motion } from 'framer-motion';
import { kidPalette } from '../../styles/kidPalette';

interface DecorativeCloudProps {
  size?: number;
  variant?: 'puffy' | 'wispy';
  color?: string;
  className?: string;
}

export default function DecorativeCloud({
  size = 120,
  variant = 'puffy',
  color = kidPalette.sky,
  className = '',
}: DecorativeCloudProps) {
  const height = Math.round(size * 0.55);

  return (
    <motion.svg
      width={size}
      height={height}
      viewBox="0 0 120 66"
      fill="none"
      className={`pointer-events-none ${className}`}
      animate={{ y: [0, -6, 0] }}
      transition={{ repeat: Infinity, duration: 4, ease: 'easeInOut' }}
    >
      {variant === 'puffy' ? (
        <path
          d="M100 50C100 50 110 50 112 42C114 34 106 30 100 30C100 20 92 12 80 12C72 12 66 16 62 22C58 16 50 12 42 14C34 16 28 24 28 32C20 30 12 36 12 44C12 52 18 56 26 54C26 58 30 62 36 62H96C102 62 106 58 106 54C106 52 104 50 100 50Z"
          fill={color}
          opacity={0.25}
        />
      ) : (
        <path
          d="M10 44C10 44 20 36 36 38C52 40 56 32 66 30C76 28 84 34 90 32C96 30 104 36 110 40C110 40 98 46 82 44C66 42 58 48 46 46C34 44 20 48 10 44Z"
          fill={color}
          opacity={0.2}
        />
      )}
    </motion.svg>
  );
}
